// extracted by mini-css-extract-plugin
module.exports = {"ForumGhostButton":"styles-module__ForumGhostButton___ekyyy"};